export default __webpack_public_path__ + "static/790-4625733e367ddfeb188660e515cd80b7.gif";